"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AudioInputFailed = AudioInputFailed;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _constants = require("@studio/constants");
var _Refresh = require("../../../components/Modals/Refresh/Refresh");
function AudioInputFailed() {
  var isOpen = (0, _reactRedux.useSelector)(function (state) {
    var _state$modal;
    return ((_state$modal = state.modal) === null || _state$modal === void 0 ? void 0 : _state$modal.type) === _constants.AUDIO_INPUT_FAILED;
  });
  var title = 'Unable to Join Session';
  var content = _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("p", null, "Your microphone is currently inaccessible. Make sure one is connected and not in use by another application."), _react["default"].createElement("p", null, _react["default"].createElement("em", null, "Refresh your browser to try again.")));
  return _react["default"].createElement(_Refresh.RefreshModal, {
    isOpen: isOpen,
    title: title
  }, content);
}